<template>
	<div class="s-w-full s-bg-gray-100 s-min-h-screen">
		<!-- Max width wrapper -->
		<div class="s-p-4 s-max-w-6xl s-m-auto">
			<!-- Headline -->
			<div class="s-w-full s-flex s-items-center s-mb-4 ">
				<div class="s-w-1/2 s-text-2xl">{{ $t("products.loadingCodes") }}</div>
				<div class="s-w-1/2 s-flex s-justify-end">
					<JButton @click="showCreateModal = !showCreateModal">
						{{ $t("products.add") }}
					</JButton>
				</div>
			</div>

			<!-- When there are some products -->
			<template>
				<!-- Search -->
				<div class="s-w-full s-mb-4">
					<JInputText v-model="textSearch" placeholder="Search name, code..." />
				</div>

				<!-- Products -->
				<CTable :header="tableHeader" :list="list">
					<template v-slot="{ item }">
						<CTableRow>
							<CTableCell
								class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900"
							>
								{{ item.name }}
							</CTableCell>
							<CTableCell
								class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900"
							>
								{{ item.code }}
							</CTableCell>
							<CTableCell
								class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900"
							>
								{{ item.value }}
							</CTableCell>
							<CTableCell
								class="s-px-6 s-py-4 s-whitespace-no-wrap s-border-b s-border-gray-200 s-text-sm s-leading-5 s-font-medium s-text-gray-900 s-text-right"
							>
								<JButton variant="default-light-xs" @click="showUpdateModal = true">{{ $t("products.update") }}</JButton>
							</CTableCell>
						</CTableRow>
					</template>
				</CTable>

				<div class="s-h-12 s-w-full s-px-4 s-my-4 s-flex s-justify-center s-items-center">
					<!-- Loading -->
					<div v-if="isLoading">
						<JSpinner variant="indigo" type="dots" :delay="0" />
					</div>
				</div>
			</template>

			<!-- Create Modal -->
			<Portal to="layer0">
				<CModal :isVisible="showCreateModal">
					<JBox class="s-p-8">
						<CJsonLogicDiscounts @cancel="showCreateModal = false" @input="showCreateModal = false">
							<template v-slot="{ handleCancel, handleSave }">
								<JFlex class="s-justify-between s-mt-6">
									<JButton variant="default-light" @click="handleSave">{{ $t("products.add") }}</JButton>
									<JButton variant="white" class="s-ml-4" @click="handleCancel">{{ $t("products.cancel") }}</JButton>
								</JFlex>
							</template>
						</CJsonLogicDiscounts>
					</JBox>
				</CModal>
			</Portal>

			<!-- Update Modal -->
			<Portal to="layer1">
				<CModal :isVisible="showUpdateModal">
					<JBox class="s-p-8">
						<CJsonLogicDiscounts
							@cancel="showUpdateModal = false"
							@input="showUpdateModal = false"
							@remove="showUpdateModal = false"
						>
							<template v-slot="{ handleCancel, handleSave, handleRemove }">
								<JFlex class="s-justify-between s-mt-6">
									<JFlex>
										<JButton variant="default-light" @click="handleSave">{{ $t("products.update") }}</JButton>
										<JButton variant="white" class="s-ml-4" @click="handleCancel">{{ $t("products.cancel") }}</JButton>
									</JFlex>
									<JButton variant="error-light" @click="handleRemove">{{ $t("products.remove") }}</JButton>
								</JFlex>
							</template>
						</CJsonLogicDiscounts>
					</JBox>
				</CModal>
			</Portal>
		</div>
	</div>
</template>

<script>
import CJsonLogicDiscounts from "@/modules/core/components/CJsonLogicDiscounts"

export default {
	components: { CJsonLogicDiscounts },

	data() {
		return {
			textSearch: null,
			isLoading: false,

			showCreateModal: false,
			showUpdateModal: false,

			tableHeader: [{ label: "Name" }, { label: "Code" }, { label: "Value" }, { label: "" }],

			// HACK: just populating
			list: Array.from(new Array(30)).map((item, i) => ({
				id: i,
				name: `Item ${i + 1}`,
				code: `${i}ASD2T${i}`,
				value: `${i * 2}%`,
				item
			}))
		}
	}
}
</script>
